/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import styled from 'styled-components';
import { buttonCss, ButtonProps } from './styles/internal/button';
import { MarginProps } from './styles/internal/marginPropStyles';

export const Button = styled.button<ButtonProps & MarginProps>`
  ${buttonCss}
`;

Button.defaultProps = {
  inline: false,
  secondary: false,
  size: 'lg'
};
